"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    staticClass: "modal-custom-field",
    attrs: {
      width: 650,
      active: true,
      scroll: "keep"
    }
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "media"
  }, [_c("div", {
    staticClass: "media-content"
  }, [_c("button", {
    staticClass: "btn-x-close",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.cancelModal
    }
  }, [_c("i", {
    staticClass: "icon-ic_close"
  })]), _vm._v(" "), _c("p", {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + _vm._s(_vm.item.register) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "content"
  }, [_c("form", [_c("app-input", {
    attrs: {
      value: _vm._f("datePost")(_vm.dateCreated),
      label: "Data de criação",
      placeholder: "data",
      disabled: ""
    }
  }), _vm._v(" "), _vm.item.plot ? _c("b-field", {
    attrs: {
      label: "Local"
    }
  }, _vm._l(_vm.item.plot, function (local, idx) {
    return _c("div", {
      key: idx
    }, [_c("app-input", {
      attrs: {
        placeholder: "Local"
      },
      model: {
        value: _vm.form.plot[idx],
        callback: function callback($$v) {
          _vm.$set(_vm.form.plot, idx, $$v);
        },
        expression: "form.plot[idx]"
      }
    })], 1);
  }), 0) : _vm._e(), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("app-select", {
    attrs: {
      label: "Cliente",
      placeholder: "cliente",
      error: _vm.$v.form.clientId.$error,
      items: _vm.listCustomers,
      option: "id",
      "name-item": "name",
      expanded: ""
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.clientId, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.clientId.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.clientId, "$model", $$v);
      },
      expression: "$v.form.clientId.$model"
    }
  }), _vm._v(" "), _c("b-button", {
    staticClass: "btn-add-field",
    on: {
      click: _vm.openModalNewCustomer
    }
  }, [_vm._v("\n              Novo cliente\n            ")])], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("app-input", {
    attrs: {
      label: "Peso da balança",
      placeholder: "Peso",
      error: _vm.$v.form.clientId.$error,
      disabled: "",
      expanded: ""
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.clientId, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.clientId.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.clientId, "$model", $$v);
      },
      expression: "$v.form.clientId.$model"
    }
  }), _vm._v(" "), _c("b-button", {
    staticClass: "btn-add-field",
    on: {
      click: _vm.readWeight
    }
  }, [_vm._v("\n              Ler dados da balança\n            ")])], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Serviço vinculado"
    }
  }, [_c("b-autocomplete", {
    attrs: {
      data: _vm.listServices,
      placeholder: "Busque o serviço vinculado",
      field: "title",
      loading: _vm.isFetching
    },
    on: {
      typing: _vm.getAsyncData,
      select: function select(option) {
        return _vm.selectService(option);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("div", {
          staticClass: "media"
        }, [_c("div", {
          staticClass: "media-content"
        }, [_vm._v("\n                    " + _vm._s(props.option.name) + "\n                    "), _c("br"), _vm._v(" "), _c("small", [_vm._v("\n                      Data: " + _vm._s(_vm._f("dateCompleteNoTZ")(props.option.dueDate)) + "\n                    ")]), _vm._v(" "), _c("br"), _vm._v("\n                    Feito por:\n                    "), _c("br"), _vm._v(" "), _vm._l(props.option.workers, function (itemWK, idxc) {
          return _c("small", {
            key: idxc,
            staticClass: "item-user-worked"
          }, [_vm._v("\n                      " + _vm._s(itemWK.firstName) + _vm._s(itemWK.lastName) + "\n                    ")]);
        })], 2)])];
      }
    }])
  })], 1), _vm._v(" "), _vm.selectedService.id ? _c("div", {
    staticClass: "content-service-selected"
  }, [_c("b", [_vm._v("Serviço vinculado:")]), _vm._v(" " + _vm._s(_vm.selectedService.name)), _c("br"), _vm._v(" "), _c("b", [_vm._v("Data:")]), _vm._v(" " + _vm._s(_vm._f("dateComplete")(_vm.selectedService.dueDate))), _c("br"), _vm._v(" "), _c("b", [_vm._v("Feito por:")]), _c("br"), _vm._v(" "), _vm._l(_vm.selectedService.workers, function (itemWKK, idx) {
    return _c("small", {
      key: idx,
      staticClass: "item-user-worked"
    }, [_vm._v("\n              " + _vm._s(itemWKK.firstName) + _vm._s(itemWKK.lastName) + "\n            ")]);
  }), _vm._v(" "), _c("div", {
    staticClass: "content-data-steps"
  }, [_c("b", [_vm._v("Dados Informados:")]), _c("br"), _vm._v(" "), _vm._l(_vm.stepsFinishedsData, function (itemStep, idxx) {
    var _itemStep$customField;
    return _c("div", {
      key: idxx
    }, [_c("h5", [_vm._v(_vm._s(((_itemStep$customField = itemStep.customField) === null || _itemStep$customField === void 0 ? void 0 : _itemStep$customField.label) || ""))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(itemStep.customFieldValue))])]);
  })], 2)], 2) : _vm._e(), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Observação"
    }
  }, [_c("b-input", {
    attrs: {
      type: "textarea",
      minlength: "10",
      maxlength: "1000",
      placeholder: "Gostaria de informar alguma nota"
    },
    model: {
      value: _vm.form.note,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "note", $$v);
      },
      expression: "form.note"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    staticClass: "row-save-form"
  }, [_c("b-button", {
    staticClass: "btn-save-form",
    on: {
      click: _vm.resolved
    }
  }, [_vm._v("\n              Salvar\n            ")])], 1)], 1)])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;